import ApiOptions from '~/api/v4/api-options';
import Client from '~/types/api/api-module';

const CUSTOMER_SEGMENTS_URL = `${process.env.API_VPNONTRADER_HOST}/v1/customer-segments`;

export default Client.wrap({
  getCustomerSegment(segmentId: string) {
    return this.get(`${CUSTOMER_SEGMENTS_URL}/${segmentId}`, 'product.*.*', {
      enableAuthHeader: true,
      ...new ApiOptions(),
    });
  },
});
